import { dedupeInviteSearchPersons } from "#webapp/src/components/invite-search/utils/dedupeInviteSearchPersons";
import { isNull } from "lodash";
import { InviteSearchPerson, SearchPersonFromGQL } from "../types";
import { convertSearchPersonToInviteSearchPerson } from "./convertSearchPersonToInviteSearchPerson";

const MAX_SUGGESTION_LENGTH = 20;

export type SuggestedOrgInivteEdgeFromGQL = {
  __typename: "SuggestedOrgInviteEdge";
  node: {
    __typename: "SuggestedOrgInvite";
    id: string;
    targetCalendarId: string | null;
    targetProfile: {
      __typename: "UserProfile";
      givenName: string | null;
      familyName: string | null;
      externalImageUrl: string | null;
    } | null;
  } | null;
} | null;

export const getDefaultInviteSuggestions = (
  suggestions: SuggestedOrgInivteEdgeFromGQL[] | null,
  defaultSearchPersons: SearchPersonFromGQL[] | null,
) => {
  let defaultSuggestions: InviteSearchPerson[] = [];

  if (!!suggestions) {
    suggestions.forEach((suggestion) => {
      if (isNull(suggestion)) return;

      const profile = suggestion.node?.targetProfile;
      const primaryCalendarId = suggestion.node?.targetCalendarId ?? "";
      const inviteSearchPerson = {
        profile: {
          givenName: !!profile && !!profile?.givenName ? profile.givenName : primaryCalendarId, // if no user profile or givenName, show primaryEmail
          familyName: !!profile && !!profile?.familyName ? profile.familyName : "",
          externalImageUrl:
            !!profile && !!profile?.externalImageUrl ? profile.externalImageUrl : "",
        },
        primaryCalendarId: primaryCalendarId,
        suggested: true,
        isUser: false,
      };
      defaultSuggestions.push(inviteSearchPerson);
    });
  }
  const defaultInitialSearch = !!defaultSearchPersons
    ? defaultSearchPersons.map((person) => {
        return convertSearchPersonToInviteSearchPerson(person);
      })
    : [];

  const suggestionLength = defaultSuggestions.length;

  if (defaultSuggestions.length >= MAX_SUGGESTION_LENGTH) {
    return defaultSuggestions;
  } else {
    const initialSearchLength = MAX_SUGGESTION_LENGTH - suggestionLength;
    const slicedSearchResults = defaultInitialSearch?.slice(0, initialSearchLength) ?? [];
    return dedupeInviteSearchPersons(defaultSuggestions, slicedSearchResults);
  }
};
